<script setup>
import {ref,watch,defineExpose,defineProps,defineEmits,onMounted} from "vue";
import Combobox from "@/components/customs/SearchableCombobox.vue";
//import JSONbig from 'json-bigint'; // For handling big integers
import apiService from "@/services/apiService";

defineExpose({
  preSelectOption,
  clearSelection,
  setCbOptions
});

const emit = defineEmits(['item-selected','item-added'])

const props = defineProps({
    placeholder: String,
    apiUrl: {
        type: String,
        default: null
    },
    cancreateitem: {
        type: Boolean,
        default: false
    },
    isLocal:{
      type: Boolean,
      default: false
    },
    options: {
    type: Array,
    default: () => [],
  },
});


const loadUser = ref();
const comboboxRef = ref(null);

function setCbOptions(opts){
  comboboxRef.value.setOptions(opts);
}

function preSelectOption(record){
/*
 comboboxRef.value.setSelected({
    value: record.sysfkid,  // or whatever ID field you use
    label: record.name,
    sysfkid: record.sysfkid // include original ID if needed
  });
  
  // Or add it to options if not already there
  comboboxRef.value.addOption({
    value: record.sysfkid,
    label: record.name
  });*/
  comboboxRef.value.setSelected(record);
  comboboxRef.value.addOption(record);

}

function clearSelection(){
     comboboxRef.value.setSelected({label: "", value: 0});
}


// eslint-disable-next-line
watch(loadUser, (newValue, oldValue) => {
    emit("item-selected",newValue)
  //oldValue
}, { immediate: true }); // `immediate: true` runs on component mount
async function loadUsers(query, setOptions) {
  try {
    const response = await apiService.get(props.apiUrl, {  q: query }, true);
    
    // Map response to { value, label } format
    const mappedOptions = response.data.map(acct => ({
      value: acct.value,  // or `acct.id` if needed
      label: acct.text,    // or `acct.name` depending on your API
      raw: acct
    }));

    setOptions(mappedOptions);
  } catch (error) {
    console.error('Failed to load users:', error);
    setOptions([]); // Fallback to empty array on error
  }
}

onMounted(()=>{
 // alert(props.options)
});
// eslint-disable-next-line 
function onAddItem(item){
   // alert(JSON.stringify(item));
   //emit('item-added',item)
  }
// eslint-disable-next-line
function createUser(option, setSelected) {
  /*fetch("http://127.0.0.1:8001/users", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name: option.label,
    }),
  })
    .then(response => response.json())
    .then(user => {
      setSelected({
        value: user.id,
        label: user.name,
      });
    });*/
   emit('item-added',option)
   setTimeout(()=>{
   setSelected({
    value: 0,
    label: ''
   },300);
   });

    //alert(JSON.stringify(option));
}
</script>

<template>
  
  <Combobox v-if="props.cancreateitem && !props.isLocal"
    ref="comboboxRef"
    :load-options="loadUsers"
    :create-option="createUser"
    :place-holder="props.placeholder"
    v-model="loadUser"
    @add-item="onAddItem"
  />
  <Combobox v-else-if="!props.cancreateitem && props.isLocal"
    ref="comboboxRef"
    :place-holder="props.placeholder"
    :options="props.options"
  />
<Combobox v-else
    ref="comboboxRef"
    :load-options="loadUsers"
    :place-holder="props.placeholder"
    v-model="loadUser"
    @add-item="onAddItem"
  />

</template>